// src/pages/HomePage.js
import React from "react";
import { Link } from "react-router-dom";

function HomePage() {
  return (
    <div>
      <h2>Welcome to My League App</h2>
      <p>Use the navigation below to explore the app.</p>
      <nav>
        <ul style={{ listStyle: "none", padding: 0 }}>
          <li>
            <Link to="/login">Login</Link>
          </li>
          <li>
            <Link to="/signup">Sign Up</Link>
          </li>
          <li>
            <Link to="/team-options">Team Options</Link>
          </li>
          <li>
            <Link to="/create-team">Create a New Team</Link>
          </li>
          <li>
            <Link to="/join-team">Join an Existing Team</Link>
          </li>
          <li>
            <Link to="/my-teams">View My Teams</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default HomePage;
